
import { PuttSituation } from "@/types/golf";

export const roughApproaches: PuttSituation = {
  id: 15,
  name: "Approches dans le rough",
  image: "/lovable-uploads/694ec337-840d-477f-b42d-81735827e253.png",
  description: "Sur le green d'approche ou sur le parcours choisissez un trou et matérialisez la position de départ de cette situation de jeu. Placer une marque au point I=15m disposée entre le bord du green et un trou à 10 m minimum du bord de green. Jouez ensuite 10 balles.",
  distances: [
    { point: "I", distance: 15, ballCount: 10 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 4 },
    { condition: "Balle à moins de 1m", points: 2 },
    { condition: "Balle entre 1m et 2m", points: 1 },
    { condition: "Balle au-delà de 2m", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 38 },
    { points: 1, index: 33 },
    { points: 2, index: 29 },
    { points: 3, index: 26 },
    { points: 4, index: 23 },
    { points: 5, index: 20 },
    { points: 6, index: 17 },
    { points: 7, index: 14 },
    { points: 8, index: 11 },
    { points: 9, index: 8 },
    { points: 10, index: 5 },
    { points: 11, index: 0 },
    { points: 12, index: -2 },
    { points: 13, index: -4 },
    { points: 14, index: -6 },
    { points: 15, index: -7 },
    { points: 16, index: -8 },
  ],
};
